<template>
        <div style="min-height: 200px">
            <loading-progress-bar :loading="loading"></loading-progress-bar>
            <vue-plotly disable-responsive v-if="showCol&&!loading" :data="mydata" :white-mode="whiteMode" :layout="layout" ref="plot1" :options="options"></vue-plotly>
            <vue-plotly disable-responsive v-if="showCol&&!loading" :data="mySumData" :white-mode="whiteMode" :layout="sumLayout" ref="plot2" :options="options"></vue-plotly>
        </div>
</template>

<script>
    import {getAnomalies, getAnomaliesSummary} from '@/helper'
    import VuePlotly from '@/components/VuePlotly'
    import LoadingProgressBar from '../LoadingProgressBar'
    import Plotly from 'plotly.js/dist/plotly'
    import moment from 'moment'
    export default {
        name: 'AnomalySummaryBase',
        components: {LoadingProgressBar, VuePlotly},
        props:{
            range: Object,
            equipment: String,
            whiteMode: {type: Boolean, default: false},
        },
        data () {
            return {
                variableX: null,
                variableY: null,
                maintenanceDialog: false,
                maintenanceItem: null,
                plots:[],
                timeout:null,
                loadingMRButton:false,
                loading: true,
                df: null,
                showCol:true,
                showCol2:true,
                layout: {
                    autosize: true,
                    hovermode: 'closest',
                    title:this.equipment+ " Health",
                    height: 200,
                    xaxis: {
                        title: 'Time'
                    },
                    margin:{
                        l: 300,
                    },
                },
                sumLayout: {
                    hovermode: 'closest',
                    height:400,
                    autosize: true,
                    title:this.equipment+" Sensors",
                    margin:{
                        l: 300,
                        r: 50,
                        b: 160,
                        t: 30,
                        pad: 4
                    },
                    yaxis: {
                        fixedrange: true,
                    },
                    xaxis: {
                        title: 'Time'
                    }
                },
                options: {},
                mydata: [],
                mySumData: [],
                mydata2: [],
                layout2: {
                    autosize: true,
                    height:400,
                    hovermode: 'closest',
                    margin:{
                        l: 300,
                        r: 50,
                        b: 160,
                        t: 30,
                        pad: 4
                    },
                    yaxis: {
                        title: 'Sensor'
                    },
                    xaxis: {
                        title: 'Sensor'
                    },
                    title: {text: ''}
                },
                currentTime: null
            }
        },
        watch: {
            range () {
                this.refresh()
            },
            equipment () {
                this.showCol2=false;
                this.mydata2=[];
                this.refresh()
            }
        },
        computed: {
            facilityName () {
                return this.$store.state.pointsListStore.pointsList.facility_name
            }
        },
        methods: {
            relayout(ed) {
                for (let plot of this.plots){
                    let x = plot.layout.xaxis;
                    if (x.range[0] !== ed["xaxis.range[0]"] || x.range[1] !== ed["xaxis.range[1]"]){
                        Plotly.relayout(plot, ed);
                    }
                }
            },
            initPlotlySync(){
                let plots=[]
                let me=this;
                if(!this.$refs.plot1||!this.$refs.plot2){
                    setTimeout(function(){ me.initPlotlySync()}, 400);
                } else {
                    plots.push(this.$refs.plot1.$refs.container)
                    plots.push(this.$refs.plot2.$refs.container)
                    me.plots=plots;
                    plots.forEach(div => {
                        div.on("plotly_relayout", ed=> {
                            if (!ed.autosize){
                                let newl={
                                    "xaxis.range[0]":div.layout.xaxis.range[0],
                                    "xaxis.range[1]":div.layout.xaxis.range[1],
                                }
                                me.relayout(newl);
                            }

                        });
                    });
                }



            },
            debounce(callback, wait) {
                clearTimeout(this.timeout);
                this.timeout= setTimeout(() => callback(), wait);
            },
            refresh(){
                this.debounce(this.doRefresh,200);
            },
            async doRefresh () {
                this.loading = true
                let df = await getAnomaliesSummary(
                    this.equipment,
                    this.facilityName,
                    {'start': this.range.start, 'end': this.range.end}
                )
                let dfsum = await getAnomalies(
                    this.equipment,
                    this.facilityName,
                    {'start': this.range.start, 'end': this.range.end},
                    null,
                    true
                )

                let colorscaleValue = [
                    [0, process.env.VUE_APP_THEME=='dark' ? "rgb(31, 119, 180)" : '#0000FF'],
                    [1, process.env.VUE_APP_THEME=='dark' ? "rgb(214, 39, 40)" : '#FF0000']
                ]

                this.mydata = [{
                    x: df['timestamp'],
                    y: _.map(df['timestamp'], function(x) {return 'score'} ),
                    z: df['value'],
                    type: 'heatmap',
                    mode: 'markers',
                    colorscale: colorscaleValue,
                    zmin:0,
                    zmax:1
                }]
                let uniques=[...new Set(dfsum['sensor_name'])]
                this.mySumData = [{
                    x: dfsum['timestamp'],
                    y: dfsum['sensor_name'],
                    z: dfsum['value'],
                    type: 'heatmap',
                    mode: 'markers',
                    colorscale: colorscaleValue,
                    zmin:0,
                    zmax:1
                }]
                this.sumLayout.height=Math.max(400,24*uniques.length)
                this.loading = false
                let me=this;
                setTimeout(function(){ me.initPlotlySync()}, 400);
            },
            async handleClick1(data) {
                this.showCol2=false

                this.currentTime = data.points[0].x
                let startDate = moment(data.points[0].x).format('YYYY-MM-DD HH:mm:ss')
                let endDate = moment(data.points[0].x).format('YYYY-MM-DD HH:mm:ss')
                let df = await getAnomalies(
                    this.equipment,
                    this.$store.state.pointsListStore.pointsList.facility_name,
                    {'start': startDate, 'end': endDate}
                )
                let output = {
                    x: [],
                    y: [],
                    z: []
                }
                for (let i=0; i <df['timestamp'].length; i++) {
                    let variables = df['name'][i].split("__")
                    output.x.push(variables[0])
                    output.y.push(variables[1])
                    output.z.push(df['value'][i])
                    output.y.push(variables[0])
                    output.x.push(variables[1])
                    output.z.push(df['value'][i])
                }
                let colorscaleValue = [
                    [0, process.env.VUE_APP_THEME=='dark' ? "rgb(31, 119, 180)" : '#0000FF'],
                    [1, process.env.VUE_APP_THEME=='dark' ? "rgb(214, 39, 40)" : '#FF0000']
                ]
                let axis=output['x'].reduce((unique,item)=>unique.includes(item) ? unique : [...unique,item], []).sort();
                this.layout2.xaxis.categoryorder='array';
                this.layout2.xaxis.categoryarray=axis;
                this.layout2.yaxis.categoryorder='array';
                this.layout2.yaxis.categoryarray=axis;
                this.layout2.height=Math.max(400,25*axis.length)
                this.mydata2 = [{
                    x: output['x'],
                    y: output['y'],
                    z: output['z'],
                    type: 'heatmap',
                    mode: 'markers',
                    colorscale: colorscaleValue,
                    zmin:0,
                    zmax:1
                }]
                this.layout2.title.text = "Issues Diagnostics for " + this.currentTime
                this.showCol2=true;
                let me=this
                setTimeout(x=>this.showCol=false,300);
                setTimeout(x=>this.showCol=true,310);
                setTimeout(function(){ me.initPlotlySync()}, 600);
            },
            handleClickMatrix(data) {
                this.variableX = data.points[0].x
                this.variableY = data.points[0].y
                this.$refs.anomalyscatter.refresh()
                this.showCol2=false;
                setTimeout(x=>this.showCol2=true,10);
            },
            handleClickJump() {
                let startDate = new Date(this.currentTime)
                startDate.setDate(startDate.getDate() - 3)
                let endDate = new Date(this.currentTime)
                endDate.setDate(endDate.getDate()+3)
                let output = {
                    path: '/equipment-plots',
                    query: {
                        rangeStart: startDate.toISOString().slice(0,10),
                        rangeEnd: endDate.toISOString().slice(0,10),
                        equipment: this.equipment
                    }
                }
                if(this.currentTime){
                    output.query.highlightTime=this.currentTime
                }
                this.$router.push(output)
            },
            handleMaintenanceClick(){
                let startDate=moment(this.$refs.plot2.layout.xaxis.range[0]).format('YYYY-MM-DD HH:mm:ss')
                let endDate=moment(this.$refs.plot2.layout.xaxis.range[1]).format('YYYY-MM-DD HH:mm:ss')
                let newmr={
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'equipment': this.equipment,
                    'maintenance_date_from': startDate,
                    'maintenance_date_to': endDate,
                    'maintenance_label':'Anomaly',
                    'url': '/modelsummary?equipment='+this.equipment+'&rangeStart='+startDate+"&rangeEnd="+endDate
                }
                this.maintenanceItem={...newmr}
                this.maintenanceDialog=true
            }
        },
        mounted () {
            this.refresh()
        }
    }
</script>

<style scoped>

</style>
